import { getFeature } from 'Cloud/Application/FeaturesEs6';

const value: 'a' | 'b' = getFeature('btn-hide-action');

export const buttonHideActionIcon: boolean = value === 'b';
